import { styles, variants, LinkTheme } from '../LinkStyles.css';
import { baseTheme } from './LinkBaseTheme.css';
import { multiVariantStyles } from './LinkVariants.css';
/*******************
 * Component Theme
 *******************/

const LinkStableTheme: LinkTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { LinkStableTheme };
